import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';

export class BaselineCriteria extends BasicCriteria {
chronoCode: string;
keyLike: string;
keyLikes: string[];
level: number | null;
levels: number[];
parentKey: string;
scenarioCode: string;
visionCode: string;
visionCodeList: string[];
visionStepLevel: number | null;
visionStepPerimeterCode: string;
}

